<template>
    <div class="overflow-auto">
        <div class="input-group mt-0 mb-4 align-items-stretch">
			<button class="input-group-prepend search-icon" @click="doSearch">
				<img :src="`${publicPath}/img/gep/icon/search.svg`">
			</button>
            <input type="text" :placeholder="$t('Search')" class="form-control no-border pl-2" v-model="search" v-on:keyup.enter="doSearch">
		</div>

        <div class="block-account p-3 mb-2 mt-1" v-for="item in data">
            <div class="d-flex align-items-center">
                <img :src="`${publicPath}/img/gep/${$route.query.user_type}.svg`" width="50px">
                <div class="px-3 d-flex flex-column">
                    <div class="fz-20 fw-700">{{ item.applyId }}</div>
                    <div class="fz-14 fw-400">{{ item.accountPayeeType }}</div>
                </div>
                <button class="btn btn-primary sub-account ml-auto" @click="handleSubAccount(item)">View Detail</button>
            </div>
            <hr>
            <div class="d-flex mb-3">
                <span class="fz-16 fw-500 text-grey7">User Number</span>
                <span class="ml-auto fz-16 fw-600">{{ item.userNo }}</span>
            </div>
            <div class="d-flex mb-3">
                <span class="fz-16 fw-500 text-grey7">Account Name</span>
                <span class="ml-auto fz-16 fw-600">{{ item.accountName }}</span>
            </div>
            <div class="d-flex mb-3">
                <span class="fz-16 fw-500 text-grey7">Status</span>
                <span class="ml-auto fz-16 fw-600">{{ item.txt_status }}</span>
            </div>
            <div class="d-flex mb-3">
                <span class="fz-16 fw-500 text-grey7">Created At</span>
                <span class="ml-auto fz-16 fw-600">{{ item.created_at }}</span>
            </div>
        </div>

        <div v-if="isLoading" class="dot-loading mt-3">
            <ul class="loader-circle">
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    </div>
    
  </template>
  
  <script>
  import CreateAccount from '@/services/CreateAccount';
  
  const STATUS = {
    1:"Processing",
    2:"Approved",
    3:"Rejected"
  };
  
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
        isLoading:false,
        data:[],
        search:'',
      };
    },
    methods: {
        doSearch(){

        },
        handleSubAccount(data){
            this.$emit('sub-account',data);
        },
        checkError(err){
            const response = err.response;
            try{
            if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                    path: '/login', 
                    });
                }
            else{
                if(localStorage.getItem("token")){
                var msg = (response.data)?response.data.message:err.message;
                this.$notify({
                    type: 'warn',
                    text: msg
                })
                }
            }
            }catch(e){
            console.log(err);
            }        
        }
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.isLoading = true;
            CreateAccount.listSubAccount({
                search:self.search,
                start:0,
                length:-1
            }).then((response)=>{
                if (response.status == 200) {
                    self.isLoading = false;
                    self.data = response.data.data;
                    
                    self.data.forEach(function(item,index) {
                        self.data[index]['txt_status'] = STATUS[item.status];
                        self.data[index]['accountPayeeType'] = item.accountPayeeType == 1?"HKG":"CHN";
                    });
                }
            });
        });
    },
    destroyed() {
      
    },
  };
  </script>
  
<style scoped>
.block-account{
    background: #F8F9FA;
    border-radius: 8px;
}
</style>